import Ajax from '../../../../../common/js/Ajax.js';
import Form from '../../../../../common/js/form/Form.js';
import MessageUtils from '../../../../../common/js/MessageUtils.js';
import TippspielWidget from '../../TippspielWidget.js';

import SEASONS_TEMPLATE from './SeasonsWidget-seasons.hbs';

export default class SeasonsWidget extends TippspielWidget {

	constructor($widget) {
		super($widget);
	}

	isLoginRequired() {
		return true;
	}

	isAdminRequired() {
		return true;
	}

	onLoginReady() {
		this.refresh();

		Form.onSubmit(this.$widget.find('.js_create-season'), action => {
			var $name = action.findField('name');
			Ajax.rpc('/createSeason', {
				name: $name.val()
			}, () => {
				$name.val('');
				action.ok();
				this.refresh();
			}, error => {
				action.error('Anlegen der Meisterschaft fehlgeschlagen', error);
			});
		});
	}

	refresh() {
		Ajax.rpc('/seasons', seasons => {
			this.$widget.find('.js_seasons').html(SEASONS_TEMPLATE(seasons));

			this.$widget.find('.js_edit').click(event => {
				var id = $(event.currentTarget).closest('.js_season').attr('data-id');
				window.location.href = '/admin/season?id=' + id;
			});

			this.$widget.find('.js_current').click(event => {
				var id = $(event.currentTarget).closest('.js_season').attr('data-id');
				Ajax.rpc('/setSeasonCurrent', {id: id}, () => {
					this.refresh();
				}, error => {
					MessageUtils.error(this.$widget, 'Aktivieren der Meisterschaft fehlgeschlagen', error);
				});
			});

			this.$widget.find('.js_delete').click(event => {
				var id = $(event.currentTarget).closest('.js_season').attr('data-id');
				Ajax.rpc('/deleteSeason', {id: id}, () => {
					this.refresh();
				}, error => {
					MessageUtils.error(this.$widget, 'Löschen der Meisterschaft fehlgeschlagen', error);
				});
			});
		}, error => {
			MessageUtils.error(this.$widget, 'Laden der Meisterschaften fehlgeschlagen', error);
		});
	}
}
